/**
 * ChipStatusPill — iter87.5. Same status pill styling used inside
 * TodoChips, exported so every chip-driven modal can carry the same
 * "Live / Open / Locked" chip in its header. Chip → modal → save now
 * tell one continuous story.
 */
const CFG = {
    live: {
        label: "Live",
        cls: "bg-volt text-black border border-black/40",
        dot: "bg-black",
        pulse: true,
    },
    open: {
        label: "Open",
        cls: "bg-cyber/15 text-cyber border border-cyber/60",
        dot: "bg-cyber",
        pulse: false,
    },
    locked: {
        label: "Locked",
        cls: "bg-white/[0.06] text-zinc-500 border border-white/10",
        dot: "bg-zinc-600",
        pulse: false,
    },
    // iter87.440 (user-reported — "it's not live or blue, it should be
    // gray") — neutral gray state for tiles that are still pickable
    // (tapping opens the modal) but have nothing real to pick from yet
    // (no bracket field) or nothing to show yet (no intel data). Same
    // gray as "locked" but a label that doesn't imply "can't act".
    pending: {
        label: "Pending",
        cls: "bg-white/[0.06] text-zinc-500 border border-white/10",
        dot: "bg-zinc-600",
        pulse: false,
    },
};

export default function ChipStatusPill({ status, label, testId, className = "" }) {
    const s = CFG[status];
    if (!s) return null;
    return (
        <span
            data-testid={testId || `chip-status-pill-${status}`}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider whitespace-nowrap ${s.cls} ${className}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${s.dot} ${s.pulse ? "animate-pulse" : ""}`} />
            {label || s.label}
        </span>
    );
}
